import { render, staticRenderFns } from "./ReportFrontTruckImage.vue?vue&type=template&id=8fe5d8fa"
import script from "./ReportFrontTruckImage.vue?vue&type=script&lang=ts"
export * from "./ReportFrontTruckImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports